import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 240;
const sidebarWidth = 64;

const useStyles = makeStyles(theme => ({
  ContentWrapper: {
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: '100%',
    '&__filters-display': {
      '&--height': {
        height: '100vh',
      },
    },
    '&__loader': {
      display: 'block',
      margin: '0 auto',
      '&__container': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-around',
      },
      '&__map': {
        height: '100vh',
        width: '100%',
      },
    },
    '&__shift': {
      marginRight: 0,
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    '&--width': {
      width: '0%',
    },
  },
  ContentWrapperCalc: {
    marginRight: open => open && -(drawerWidth - 240),
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

export { useStyles };
